export default "__VITE_ASSET__XtawCFo1__"